import React from 'react';
import Header from 'components/common/Header';
import HeadlineSection from './sections/HeadlineSection';
import Solutions from './sections/Solutions';
import Portfolio from './sections/Portfolio';
import Footer from 'components/common/Footer';
import AISection from './sections/AISection';
import Create from './sections/Create';
import DesignContent from './sections/DesignContent';
import Personalize from './sections/Personalize';
import NoCodeSolutions from './sections/NoCodeSolutions';
import IntegrationTools from './sections/IntegrationTools';
import Testimonials from './sections/Testimonials';

// Keep the section available for reuse, but do not publish it until every quote
// and attribution is current and approved.
const SHOW_TESTIMONIALS = false;

function Homepage() {
  return (
    <>
      <Header isWhite isMarketingHome />
      <main>
        <HeadlineSection />
        <NoCodeSolutions />
        <Create />
        <DesignContent />
        <Personalize />
        <AISection />
        <Portfolio />
        {SHOW_TESTIMONIALS && <Testimonials />}
        <Solutions />
        <IntegrationTools />
      </main>
      <Footer />
    </>
  );
}

export default Homepage;
